import { render, staticRenderFns } from "./InStock.vue?vue&type=template&id=0dcc3ff0&scoped=true"
import script from "./InStock.vue?vue&type=script&lang=ts"
export * from "./InStock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcc3ff0",
  null
  
)

export default component.exports